import { ManagerType } from 'src/Types/Manager'
import request from './request'

export default class ManagersService {
  static getByEventId(eventId, userId): Promise<ManagerType> {
    return request({
      url: `/managers/gg_urls?event_id=${eventId}&user_id=${userId}`,
      method: 'GET',
    })
  }

  static getByEncryptedHubId(encryptedHubId, userId): Promise<ManagerType> {
    return request({
      url: `/managers/gg_urls?encrypted_hub_id=${encryptedHubId}&user_id=${userId}`,
      method: 'GET',
    })
  }
}
